import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MdReferralFormContainer from './mdreferral/MdReferralFormContainer.jsx';
import WomReferralFormContainer from './womreferral/WomReferralFormContainer.jsx';
import SampleFormContainer from './intake_new/SampleFormContainer.jsx';
import PatientStoryFormContainer from './patient_story/PatientStoryFormContainer.jsx';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/intake_new" replace />} />
        <Route path="/intake_new" element={<SampleFormContainer />} />
        <Route path="/patient_story" element={<PatientStoryFormContainer />} />
        <Route path="/md-referral" element={<MdReferralFormContainer />} />
        <Route path="/wom-referral" element={<WomReferralFormContainer />} />
        <Route path="*" element={<Navigate to="/intake_new" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
